import CommonState from '@/class/cargo/model/parameters/CommonState'

// -------------------------
// 空运订舱4种业务模式
// -------------------------
export const CONSOLE		= new CommonState(0, '一主多分', 'Console')
//		export const CO_LOADER		= new CommonState("1", "委托同行", "Co-Loader");
export const DIRECT 		= new CommonState(2, '直单', 'Direct')
export const BACK_TO_BACK 	= new CommonState(3, '一主一分', 'Back To Back')

/**
		 * 空运出口业务模式
		 */
export const BUSINESS_MODELS = ([CONSOLE, DIRECT, BACK_TO_BACK])

export const RETAIL_SALES		= new CommonState('SX', '散销', 'Retail Sales')
export const CHARTER_FLIGHT		= new CommonState('BJ', '包机', 'Charter Flight')
export const BLOCK_SPACE_BOOKING		= new CommonState('BB', '包板', 'Block Space Booking')
export const VOLUME_COMMITMENT		= new CommonState('BL', '包量', 'Volume Commitment')
export const AGENCY_OPERATION		= new CommonState('DCZ', '代操作', 'Agency Operation')
export const RELEASE_ORDER		= new CommonState('FD', '放单', 'Release Order')
export const OTHERS		= new CommonState('QT', '其他', 'Others')
/**
 * 空出 服务产品
 * @type {CommonState[]}
 */
export const SERVICE_PRODUCT = ([RETAIL_SALES, CHARTER_FLIGHT, BLOCK_SPACE_BOOKING, VOLUME_COMMITMENT, AGENCY_OPERATION, RELEASE_ORDER, OTHERS])

export const NONE		= new CommonState('NONE', '空', 'None')
export const IS_WOOD		= new CommonState('WD', '木', 'Is_Wood')
export const NON_WOOD		= new CommonState('NWD', '非木', 'Non_Wood')

/**
 *  空出 木/非木
 * @type {CommonState}
 */
export const WOOD = ([NONE, IS_WOOD, NON_WOOD])

export const CARGO_AIRCRAFT_ONLY = new CommonState('CAO', '仅限货机', 'Cargo Aircraft Only')
export const PASSENGER_AND_CARGO_AIRCRAFT	= new CommonState('PACA', '客货均可', 'Passenger And Cargo Aircraft')

export const HANDLING_INFORMATION_WPM	= new CommonState('WPM', '', 'NO SOLID WOOD PACKING MATERIAL')
export const HANDLING_INFORMATION_ISP	= new CommonState('ISP', '', 'THE WPM WERE PROPERLY TREATED ACCORDING TO REGULATIONS ON ISPM15')
export const HANDLING_INFORMATION_PAD	= new CommonState('PAD', '', 'DANGEROUS GOODS AS PER ASSOCIATED DGD - CARGO AIRCRAFT ONLY')
export const HANDLING_INFORMATION_PAS	= new CommonState('PAS', '', 'DANGEROUS GOODS AS PER ASSOCIATED SHIPPER\'S DECLARATION')

/**
 * 危险品选项
 * @type {CommonState}
 */
export const HAZARDOUS_GOODS_OPTION = ([NONE, CARGO_AIRCRAFT_ONLY, PASSENGER_AND_CARGO_AIRCRAFT])

// -------------------------
// 主单状态
// -------------------------

export const NEW_WAYBILL 		= new CommonState('0', '新建', 'New')
export const USE_WAYBILL 		= new CommonState('1', '使用', 'Use')
export const CANCEL_WAYBILL	= new CommonState('2', '作废', 'Cancel')
export const LOAN_WAYBILL 		= new CommonState('3', '借出', 'Loan')
export const RETURN_WAYBILL 	= new CommonState('4', '返回', 'Return')
export const RELEASE_WAYBILL 	= new CommonState('5', '释放', 'Release')
export const ASSIGNED 	= new CommonState('6', '已分配', 'Assigned')
export const ALL_WAYBILL 		= new CommonState(null, 'All', 'All')

/**
		 * 主单状态列表
		 */
export const MASTER_WAYBILL_STATES = ([
  ALL_WAYBILL,
  NEW_WAYBILL,
  USE_WAYBILL,
  CANCEL_WAYBILL,
  ASSIGNED
])

export const NEW 		= new CommonState(0, '新增', 'New')
export const ASSIGNMENT 		= new CommonState(1, '分配', 'Assignment')

/**
 * 主单来源
 */
export const MASTER_WAYBILL_SOURCE = ([
  NEW,
  ASSIGNMENT
])

export const NOT_AVAILABLE 		= new CommonState(0, '不可用', 'Not available')
export const AVAILABLE 		= new CommonState(1, '可用', 'Available')

/**
 * 主单是否可用
 */
export const MASTER_WAYBILL_AVAILABLE = ([
  AVAILABLE,
  NOT_AVAILABLE
])

export const CUSTOMER_DECLARATION = new CommonState(0, '客户自报关', 'Customer Declaration')
export const DELEGATE_DECLARATION = new CommonState(1, '委托报关', 'DELEGATION Declaration')
export const SELF_DECLARATION = new CommonState(2, '自报自送', 'SELF Declaration')
export const SELF_OPERATION = new CommonState(3, '自操作', 'SELF Operation')
export const SELF_DECLARATION_MANIFEST = new CommonState(4, '自报出舱单', 'SELF Declaration Manifest')

/**
		 * 报关方式
		 */
export const CUSTOM_CLAIMS = ([
  CUSTOMER_DECLARATION,
  DELEGATE_DECLARATION,
  SELF_DECLARATION,
  SELF_OPERATION,
  SELF_DECLARATION_MANIFEST
])

export const SEAL_CLAIM = new CommonState(0, '关封报关', '')
export const NOT_SEAL_CLAIM = new CommonState(1, '非关封报关', '')
export const NO_PAPER_CLAIM = new CommonState(2, '无纸报关', '')
export const PERSONAL_CLAIM = new CommonState(3, '私人物品', '')
export const REPAIR_CLAIM = new CommonState(4, '修理物品', '')
export const CUSTOMS_DECLARATION = new CommonState(5, '买单报关', '')
export const CUSTOMS_DECLARATION_9610 = new CommonState(6, '9610报关', '')
export const EXPRESS_CUSTOMS_DECLARATION = new CommonState(7, '快件报关', '')
export const DOCUMENT_DECLARATION = new CommonState(8, '单证报关', '')
export const CUSTOMS_CLEARANCE_INTEGRATION = new CommonState(9, '通关一体化', '')

/**
		 * 报关类型
		 */
export const CUSTOM_CLAIMS2 = ([
  SEAL_CLAIM,
  NOT_SEAL_CLAIM,
  NO_PAPER_CLAIM,
  PERSONAL_CLAIM,
  REPAIR_CLAIM,
  CUSTOMS_DECLARATION,
  CUSTOMS_DECLARATION_9610,
  EXPRESS_CUSTOMS_DECLARATION,
  DOCUMENT_DECLARATION,
  CUSTOMS_CLEARANCE_INTEGRATION
])

export const DD_STUFFY_TYPE = new CommonState('DD', '门点提货', 'Door to Door')
export const SD_STUFFY_TYPE = new CommonState('SD', '自送', 'Self Delivery')
export const TP_STUFFY_TYPE = new CommonState('TP', '第三方', 'Third Party')

/**
		 * 本地服务
		 */
export const SUFFY_TYPES = ([
  DD_STUFFY_TYPE,
  SD_STUFFY_TYPE,
  TP_STUFFY_TYPE
])

export const BOOKING_STATE_NORMAL = new CommonState(0, '未确认', 'Unconfirmed')
export const BOOKING_STATE_CONFIRMED = new CommonState(1, '已确认', 'Confirmed')

/**
		 * 配舱状态
		 */
export const BOOKING_STATES = ([
  BOOKING_STATE_NORMAL,
  BOOKING_STATE_CONFIRMED
])

//		/**
//		 * 付费条款
//		 */
//		export const FREIGN_TERM:Object = {"P":"PREIGHT PREPAID", "C":"PREIGHT COLLECT"};

/**
		 * 币种
		 */
export const CURRENCY = (['CNY', 'USD', 'HKD', 'TWD', 'EUR', 'JPY'])

/**
		 * Rate Class
		 */
export const RATE_CLASSES = (['M', 'N', 'Q', 'S', 'C', 'U'])

/**
		 * flight board types.
		 */
export const BOARD_TYPES = (['PAP', 'PMC', 'PLB', 'PZA', 'PGE'])

export const PP = 'PP'
export const CC = 'CC'

export const PP_LIST = ([PP])
export const CC_LIST = ([CC])

/**
		 *组合按钮-批量操作：新增费用，导入费用，批量修改状态，批量提交，批量打印
		 */
export const BUTTON_ADD_CHARGES = new CommonState('AddCharges', '新增费用', 'AddCharges')
export const BUTTON_CHARGE_IMPORT = new CommonState('ChargeImport', '费用导入', 'ChargeImport')
export const BUTTON_EDIT_SOP_STATUS = new CommonState('EditSopStatus', '状态修改', 'EditSopStatus')
export const BUTTON_BATCH_COMMIT = new CommonState('BatchCommit', '批量提交', 'BatchCommit')
export const BUTTON_BATCH_PRINT = new CommonState('BatchPrint', '批量打印', 'BatchPrint')

/**
		 * 流程：提交，退关，撤回
		 */
export const BUTTON_SUBMISSION = new CommonState('Submission', '提交', 'Submission')
export const BUTTON_SHUTOUT = new CommonState('ShutOut', '退关', 'ShutOut')
export const BUTTON_CANCEL_SHUTOUT = new CommonState('CancelShutOut', '取消退关', 'CancelShutOut')
export const BUTTON_PRINTRETURN = new CommonState('PrintReturn', '撤回', 'PrintReturn')
export const BUTTON_INVALID = new CommonState('Invalid', '作废', 'Invalid')
export const BUTTON_CANCEL_INVALID = new CommonState('CancelInvalid', '取消作废', 'CancelInvalid')

/**
		 * 打印：打印，利润分析打印
		 */
export const BUTTON_PRINT = new CommonState('print', '打印', 'print')
export const BUTTON_PRINTP_PROFIT_ANALYSIS = new CommonState('PrintProfitAnalysis', '利润分析打印', 'PrintProfitAnalysis')

/**
		 * 新增：新增，新增主票
		 */
export const BUTTON_ADD = new CommonState('add', '新增', 'add')
export const BUTTON_ADDHBL = new CommonState('AddHbl', '新增主票', 'AddHbl')

/**
 * 报关状态
 */
export const CUSTOMS_STATES = ([
  new CommonState(1, '已录入', '已录入'),
  new CommonState(2, '已拉单', '已拉单'),
  new CommonState(3, '在前台', '在前台'),
  new CommonState(4, '报好', '报好'),
  new CommonState(5, '未报好', '未报好'),
  new CommonState(6, '海关查验', '海关查验'),
  new CommonState(7, '商检查验', '商检查验'),
  new CommonState(8, '已查未放行', '已查未放行'),
  new CommonState(9, '改单', '改单'),
  new CommonState(10, '等通知报关', '等通知报关'),
  new CommonState(11, '海关已查', '海关已查'),
  new CommonState(12, '海关查验有问题', '海关查验有问题')
])

/**
 * 协议类型
 */
export const PROTOCOL_TYPES = ([
  new CommonState('fixed', '固定板', 'Fixed'),
  new CommonState('floating', '浮动板', 'Floating'),
  new CommonState('protocol', '协议', 'Protocol'),
  new CommonState('casebycase', '议价', 'Casebycase'),
  new CommonState('markup', '加价', 'Markup')
])

export const GENERAL_CHARGE = new CommonState('generalCharge', '普通费用', 'General Charge')

/**
 * OtherChargeItemMeasure
 */
export const OTHER_CHARGE_ITEM_MEASURE = ([
  new CommonState('chargeWeight', '按计费重计算', 'Charge Weight'),
  new CommonState('job', '按票数计算', 'Job Count'),
  new CommonState('wt', '按毛重计算', 'WT'),
  new CommonState('quantity', '按件数计算', 'Quantity'),
  GENERAL_CHARGE
])

/**
 * OtherChargeItemMeasure（空进）
 */
export const OTHER_CHARGE_ITEM_MEASURE_AI = ([
  new CommonState('chargeWeight', '按计算重计算', 'Charge Weight'),
  new CommonState('job', '按票数计算', 'Job Count'),
  new CommonState('wt', '按毛重计算', 'WT')
])

/**
 * 客户/供应商分泡收取项
 */
export const SPLIT_BUBBLE_COLLECT_ITEMS = ([
  new CommonState(50, '1/2', '1/2'),
  new CommonState(33, '1/3', '1/3'),
  new CommonState(25, '2/8', '2/8'),
  new CommonState(67, '2/3', '2/3'),
  new CommonState(43, '3/7', '3/7')
])

// 到货方式 1-我司，2-晚进，3-现场，4-外仓，5-提货
export const NO_HAVE = new CommonState(0, '无', 'not have')
export const OUR_COMPANY = new CommonState(1, '我司', 'Our company')
export const LATE_ARRIVAL = new CommonState(2, '晚进', 'Late arrival')
export const ON_SITE = new CommonState(3, '现场', 'On site')
export const EXTERNAL_WAREHOUSE = new CommonState(4, '外仓', 'External warehouse')
export const PICK_UP = new CommonState(5, '提货', 'Pick up')
export const ARRIVAL_METHOD = [NO_HAVE, OUR_COMPANY, LATE_ARRIVAL, ON_SITE, EXTERNAL_WAREHOUSE, PICK_UP]

// 空运标签 1-无分标签，2-有分代制，3-有分客送，4-免制标签
export const NO_SEPARATE_LABEL = new CommonState(1, '无分标签', 'no separate label')
export const WITH_SEPARATE_SYSTEM = new CommonState(2, '有分代制', 'with separate generation system')
export const WITH_SEPARATE_DELIVERY = new CommonState(3, '有分客送', 'with separate customer delivery')
export const LABEL_FREE = new CommonState(4, '免制标签', 'label free')
export const AIR_FLIGHT_LABEL = [NO_HAVE, NO_SEPARATE_LABEL, WITH_SEPARATE_SYSTEM, WITH_SEPARATE_DELIVERY, LABEL_FREE]

// 拣货状态 0未拣货 1已拣货
export const NOT_PICKED = new CommonState(0, '未拣货', 'Not picked goods')
export const HAS_PICKED = new CommonState(1, '已拣货', 'Selected goods')
export const PICKING_STATUS = [NOT_PICKED, HAS_PICKED]

// 出仓状态 0未出仓 1已出仓
export const UN_OUTBOUND = new CommonState(0, '未出仓', 'Not yet released from warehouse')
export const HAS_OUTBOUND = new CommonState(1, '已出仓', 'Out of warehouse')
export const OUTBOUND_STATUS = [UN_OUTBOUND, HAS_OUTBOUND]

// 卖/买价类型 1单价 2总价
export const UNIT_PRICE = new CommonState(0, '单价', 'unit price')
export const TOTAL_RRICE = new CommonState(1, '总价', 'total price')
export const SELL_BUY_PRICE = [UNIT_PRICE, TOTAL_RRICE]
